<template>
    <DCard
        padding
    >
        <DRow
            class="mb-3"
            align-vertical="end"
        >
            <DCol
                sm="2"
                class="pt-1"
            >
                <label class="form-label">{{ __('customers.contracts.providerbox_contracts.month') }}</label>
                <DInput
                    v-model="dataFilters.month"
                    type="month"
                    :placeholder="__('customers.contracts.providerbox_contracts.month')"
                    :is-valid="isFormFieldValid('month')"
                />
            </DCol>
            <DCol
                sm="2"
                class="pt-1"
            >
                <label class="form-label">{{ __('customers.contracts.providerbox_contracts.module') }}</label>
                <DMultiSelect
                    :options="moduleOptions"
                    selection-type="tags"
                    :multiple="true"
                    :selection="true"
                    inline
                    @update="updateSelectedModules"
                />
            </DCol>
            <DCol
                sm="2"
                class="pt-1"
            >
                <DInput
                    id="description-id"
                    v-model="dataFilters.description"
                    :label="__('customers.contracts.providerbox_contracts.description')"
                    class="mb-0"
                />
            </DCol>
            <DCol
                sm="2"
                class="pt-1"
            >
                <label class="form-label">{{ __('customers.contracts.providerbox_contracts.start') }}</label>
                <DInput
                    id="start-date-id"
                    v-model="dataFilters.startDate"
                    type="month"
                    :placeholder="__('customers.contracts.providerbox_contracts.start')"
                    :is-valid="isFormFieldValid('startDate')"
                />
            </DCol>
        </DRow>
        <DRow class="mb-3">
            <DCol
                sm="3"
                class="d-flex gap-2"
            >
                <DButton
                    id="filter-apply"
                    :label="__('tools.providerbox.filters.filter')"
                    @click="changePage"
                />
                <DButton
                    id="filter-reset"
                    icon="filter-off"
                    :label="__('messages.actions.reset_filter')"
                    @click="resetFilters"
                />
            </DCol>
        </DRow>
        <DTable
            class="table-responsive"
            :fields="fields"
            :items="providerboxContracts.data"
        />
        <DPagination
            v-if="providerboxContracts.last_page > 1"
            :active-page="providerboxContracts.current_page"
            :pages="providerboxContracts.last_page"
            align="center"
            @update:activePage="changePage"
        />
    </DCard>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'
import _ from 'lodash'

export default {
    name: 'ProviderboxContractShow',
    layout: [App, CustomerBase],
    props: {
        customer: {
            type: Object,
            default: () => { return {} }
        },
        contract: {
            type: Object,
            default: () => { return {} }
        },
        providerboxContracts: {
            type: Array,
            default: () => { return [] }
        },
        filters: {
            type: Object,
            default: () => { return {} }
        },
        modules: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            fields: [
                { key: 'id', label: this.__('customers.contracts.providerbox_contracts.id') },
                { key: 'module', label: this.__('customers.contracts.providerbox_contracts.module') },
                { key: 'description', label: this.__('customers.contracts.providerbox_contracts.description') },
                { key: 'from', label: this.__('customers.contracts.providerbox_contracts.from') },
                { key: 'to', label: this.__('customers.contracts.providerbox_contracts.to') },
                { key: 'package', label: this.__('customers.contracts.providerbox_contracts.package') },
                { key: 'price', label: this.__('customers.contracts.providerbox_contracts.price') },
                { key: 'start', label: this.__('customers.contracts.providerbox_contracts.start') }
            ],
            dataFilters: _.cloneDeep(this.filters)
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        },
        moduleOptions () {
            const modules = _.cloneDeep(this.modules)

            for (const module in modules) {
                if (this.dataFilters.modules.includes(modules[module].value)) {
                    modules[module].selected = true
                }
            }

            return modules
        }
    },
    methods: {
        changePage (page) {
            const queryParameters = Object.fromEntries(Object.entries(this.dataFilters).filter(([_, v]) => v))

            if (page !== 1) {
                queryParameters.page = page
            }

            this.$inertia.get(this.$route('customers.customers.contracts.providerbox_contracts', {
                customer: this.customer.id,
                contract: this.contract.id
            }), queryParameters)
        },
        resetFilters () {
            this.dataFilters.month = null
            this.dataFilters.description = null
            this.dataFilters.modules = []
            this.dataFilters.start = null
        },
        updateSelectedModules (values) {
            this.dataFilters.modules = values
        }
    }
}
</script>
